import { buildRageQuitScoreFromQuitter } from "./rageQuitScore";
import { REPORT_SEMANTIC_TYPES, tryResolveReportSemantics } from "./reportSemantics";

export function getCanonicalMatchResult(match = {}) {
  const numericPair = (source, leftKey, rightKey) => {
    const scoreP1 = source?.[leftKey];
    const scoreP2 = source?.[rightKey];
    return typeof scoreP1 === "number" && typeof scoreP2 === "number"
      ? { scoreP1, scoreP2 }
      : null;
  };

  const corrected =
    Number(match?.correctionVersion || 0) > 0 ||
    String(match?.resultSource || "").includes("CORRECTION");

  // Corrections intentionally preserve the original user report. Their
  // canonical score is stored separately and must win over every old field.
  const correctedScore = corrected
    ? numericPair(match?.resumeResult, "scoreP1", "scoreP2") ||
      numericPair(match?.resumeResult, "finalScoreP1", "finalScoreP2")
    : null;

  const score =
    correctedScore ||
    numericPair(match, "finalScoreP1", "finalScoreP2") ||
    numericPair(match?.resumeResult, "finalScoreP1", "finalScoreP2") ||
    numericPair(match, "scoreP1", "scoreP2") ||
    numericPair(match?.resumeResult, "scoreP1", "scoreP2") ||
    numericPair(match?.report?.payload, "scoreP1", "scoreP2") ||
    numericPair(match?.report, "scoreP1", "scoreP2");

  let resolvedScore = score;
  const reportSemantics = tryResolveReportSemantics(match?.report || {});
  if (!resolvedScore && reportSemantics?.semanticType === REPORT_SEMANTIC_TYPES.RAGE_QUIT) {
    resolvedScore = buildRageQuitScoreFromQuitter(
      match?.report?.payload?.quitterUid,
      match?.player1Uid,
      match?.player2Uid
    );
  }

  const scoreP1 = resolvedScore?.scoreP1 ?? null;
  const scoreP2 = resolvedScore?.scoreP2 ?? null;
  const hasScore = typeof scoreP1 === "number" && typeof scoreP2 === "number";
  const status = String(match?.status || "").toLowerCase();
  const canonical = hasScore && ["confirmed", "finished", "completed"].includes(status);

  return {
    scoreP1,
    scoreP2,
    winnerUid: match?.winnerUid || null,
    loserUid: match?.loserUid || null,
    hasScore,
    canonical,
    source: correctedScore ? "admin_correction" : score ? "canonical_match" : hasScore ? "rage_quit" : "none",
  };
}
